import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toaster } from './components/toaster/toaster';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toaster],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('RivalForge');

  public isElectron = signal<boolean>(this.checkElectron());

  constructor() { }

  private checkElectron(): boolean {
    return navigator.userAgent.toLowerCase().includes('electron');
  }
}
